import { FeatureFlag } from '../FeatureFlag';

export const enableMultiIdeaSelect = new FeatureFlag({
    key: 'enable-multi-idea-select',
    createdOn: '2025-03-14',
    defaultValue: false,
});
